import { SVGProps } from "react";

const BoxIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.7631 17.3959V19.4484C13.7631 19.5065 13.7919 19.5564 13.8422 19.5854L15.4485 20.5128C15.5543 20.574 15.6858 20.498 15.6858 20.3758V17.6351L22.3159 13.8072L24.406 15.0139C24.5737 15.1107 24.6697 15.2769 24.6697 15.4705V22.5175C24.6697 22.7111 24.5737 22.8774 24.406 22.9742L18.3032 26.4976C18.1355 26.5944 17.9435 26.5944 17.7758 26.4976L11.673 22.9742C11.5053 22.8774 11.4093 22.7111 11.4093 22.5175V16.1404L13.2924 17.2276C13.4414 17.3136 13.6007 17.3697 13.7631 17.3959ZM14.2416 1.48961C14.0739 1.39279 13.882 1.39279 13.7143 1.48961L7.61144 5.01311C7.44374 5.10993 7.34776 5.2762 7.34776 5.46979V12.5167C7.34776 12.7104 7.44374 12.8766 7.61144 12.9734L13.7143 16.4969C13.882 16.5937 14.0739 16.5937 14.2416 16.4969L20.3445 12.9734C20.5122 12.8766 20.6081 12.7104 20.6081 12.5167V5.46979C20.6081 5.27615 20.5122 5.10993 20.3445 5.01311L18.2544 3.80644L11.6243 7.63438V10.3751C11.6243 10.4973 11.4928 10.5732 11.387 10.5121L9.78061 9.58465C9.7303 9.55559 9.70151 9.50576 9.70151 9.44765V6.52426L16.3316 2.69633L14.2416 1.48961ZM6.50401 10.4261L4.85174 11.3801V14.3035C4.85174 14.3616 4.88053 14.4114 4.93084 14.4405L6.53718 15.3679C6.64297 15.429 6.77449 15.3531 6.77449 15.2309V13.3373C6.88391 13.4834 7.02387 13.6085 7.18951 13.7041L10.5655 15.6533V20.6751L9.3918 21.3527C9.22411 21.4496 9.03215 21.4496 8.86446 21.3527L2.76172 17.8293C2.59402 17.7325 2.49805 17.5663 2.49805 17.3726V10.3256C2.49805 10.132 2.59402 9.96576 2.76172 9.86894L6.50401 7.70836V10.4261Z"
        fill="#69CFFD"
      />
    </svg>
  );
};

export default BoxIcon;
